import { displayDollar } from "utilities/tableUtility";
import { convertIntoDashUSFormat } from "utilities/dateUtility";
import { DefaultColumnOptions } from "hooks/useDataGrid/options";
import K from "utilities/constants";
import { nullRenderer } from "../../../submitToBilling/tableColumns";

export const commissionEarnedAmountRenderer = (params) =>
  [displayDollar(+params.value), `(USD)`].join(" ");

export const toolTipCommissionEarnedAmountRenderer = (params) => (
  <div className="client-list-tooltip">
    {[displayDollar(+params.value), `(USD)`].join(" ")}
  </div>
);

export const commissionAmountRenderer = (params) =>
  [
    displayDollar(+params.value),
    `(${params.data.submittedJobBill?.convertToCurrency})`,
  ].join(" ");

export const toolTipCommissionAmountRenderer = (params) => (
  <div className="client-list-tooltip">
    {[
      displayDollar(+params.value),
      `(${params.data.submittedJobBill?.convertToCurrency})`,
    ].join(" ")}
  </div>
);

export const createdAtRenderer = (params) =>
  convertIntoDashUSFormat(params.value);

export const tooltipCreatedAtRenderer = (params) => (
  <div className="client-list-tooltip">
    {convertIntoDashUSFormat(params.value)}
  </div>
);

export const candidateName = (params) => params.value ?? K.NullPlaceholder;

export const tooltipCandidateName = (params) => (
  <div className="client-list-tooltip">{params.value ?? K.NullPlaceholder}</div>
);

export const candidateStartDate = (params) => {
  return convertIntoDashUSFormat(params.value, false);
};

export const tooltipCandidateStartDate = (params) => (
  <div className="client-list-tooltip">
    {convertIntoDashUSFormat(params.value, false)}
  </div>
);

export const Columns = [
  {
    ...DefaultColumnOptions.Id,
    checkboxSelection: true,
    headerCheckboxSelection: true,
    suppressColumnsToolPanel: true,
  },
  {
    headerName: "Client",
    field: "submittedJobBill.client.name",
    sortable: true,
    sort: "asc",
    tooltipField: "submittedJobBill.client.name",
  },
  {
    headerName: "Candidate",
    field: "submittedJobBill.candidateName",
    sortable: true,
    tooltipField: "submittedJobBill.candidateName",
    tooltipComponent: tooltipCandidateName,
    cellRenderer: candidateName,
  },
  {
    headerName: "Candidate Type",
    field: "submittedJobBill.candidateJobEntry.hireType",
    sortable: true,
    cellRenderer: (params) =>
      K.CandidateType[params.value] || nullRenderer.cellRenderer(params),
    tooltipValueGetter: (params) => K.CandidateType[params.value],
  },
  {
    headerName: "Start Date",
    field: "submittedJobBill.candidateJobEntry.startDate",
    sortable: true,
    tooltipComponent: tooltipCandidateStartDate,
    cellRenderer: candidateStartDate,
  },
  {
    headerName: "Job Title",
    field: "submittedJobBill.jobTitle",
    sortable: true,
    tooltipField: "submittedJobBill.jobTitle",
  },
  {
    headerName: "Billing Type",
    field: "submittedJobBill.billingTypeName",
    sortable: true,
    tooltipField: "submittedJobBill.billingTypeName",
  },
  {
    headerName: "Amount",
    field: "thresholdMaker",
    sortable: true,
    tooltipField: "thresholdMaker",
    tooltipComponent: toolTipCommissionAmountRenderer,
    cellRenderer: commissionAmountRenderer,
  },
  {
    headerName: "Commission Earned",
    field: "duplicateAmount",
    sortable: true,
    tooltipField: "duplicateAmount",
    tooltipComponent: toolTipCommissionEarnedAmountRenderer,
    cellRenderer: commissionEarnedAmountRenderer,
  },
  {
    headerName: "Create Date",
    field: "createdAt",
    sortable: true,
    tooltipField: "createdAt",
    tooltipComponent: tooltipCreatedAtRenderer,
    cellRenderer: createdAtRenderer,
  },
];
